import { useQuery } from "@tanstack/react-query";
import { channelGet } from "common/api/matsend/matsend_channel";
import { QUERY_KEYS } from "constant/react_query";

export const useChannelGet = (id: string) => {
  const { data: channel } = useQuery(
    [QUERY_KEYS.MATSEND_CHANNEL_GET, id],
    async () => {
      const result = await channelGet(id);
      return result;
    },
    { staleTime: Infinity }
  );
  const result =
    typeof channel !== "undefined" && channel !== "" ? channel : null;
  return result;
};
